module.exports = __webpack_public_path__ + "ef18a62027ee0520b6aa893128e6bc9a.pdf";